const materialProduto = {
    BILINGUE: 1,
    UNIDUNETE: 2,

    desc: (value) => {
        switch(value){
            case 1:
                return 'Bilíngue';
            
            case 2:
                return 'Uni Dune Tê';

            default:
                return '-'
        }
    }
}

export default materialProduto;